<script lang="ts">
    import {createEventDispatcher, onMount} from "svelte";
    import {UrlUtil} from "../../../../lib/Common/Http/UrlUtil";
    import {HttpRequestUtil} from "../../../../lib/Common/Http/HttpRequestUtil";
    import PortalView from "../../../../component/common/Portal/PortalView.svelte";
    import EditDialogView from "../../../../component/common/Dialog/EditDialogView.svelte";
    import LabelValueView from "../../../../component/common/Value/LabelValueView.svelte";
    import InputAreaView from "../../../../component/common/Form/InputAreaView.svelte";
    import InputFileUploadView from "../../../../component/common/Input/InputFileUploadView.svelte";
    import {BinaryTable} from "../../../../lib/Table/BinaryTable";
    import {ValueUtil} from "../../../../lib/Common/Value/ValueUtil";
    import TextareaView from "../../../../component/common/Form/TextareaView.svelte";
    import {MessageStore} from "../../../../store/MessageStore";
    import {UserAgentUtil} from "../../../../lib/Common/UserAgent/UserAgentUtil";


    const dispatcher = createEventDispatcher();

    export let space;
    export let app;
    export let editData = null;


    $: title = (() => {
        if (editData == null) {
            return '';
        }
        if (ValueUtil.isEmpty(editData.id)) {
            return 'バイナリ追加';
        } else {
            return `バイナリ編集`;
        }
    })();

    $: canSave = (() => {
        if (editData == null) {
            return false;
        }
        if (editData.name == null) {
            return false;
        }
        if (editData.platform_type == null) {
            return false;
        }
        if (editData.id == null) {
            // 新規登録時
            if (editData.file == null) {
                return false;
            }

        }
        return true;
    })();

    let isLoading = false;

   
    const platformAllowFileTypeMap = {};
    platformAllowFileTypeMap[BinaryTable.PlatformType.Android] = {
        'apk': 'application/vnd.android.package-archive',
        'aab': 'application/octet-stream',


    };
    platformAllowFileTypeMap[BinaryTable.PlatformType.Gpg] = {
        'apk': 'application/vnd.android.package-archive',
        'aab': 'application/octet-stream',
    };
    platformAllowFileTypeMap[BinaryTable.PlatformType.IOS] = {
        'ipa': 'application/octet-stream',
    };
    platformAllowFileTypeMap[BinaryTable.PlatformType.Dmm] = {
        'exe': 'application/octet-stream',
        'zip': UserAgentUtil.getZipMimeType(),
    };

    $: supportFileExtensionArray = (() => {
        if (editData == null) {
            return null;
        }
        const type = editData.type;
        const platFormType = editData.platform_type;
        if (platFormType == null) {
            return null;
        }


        if (type === BinaryTable.Type.Application) {
            if (!(platFormType in platformAllowFileTypeMap)) {
                return null;
            }
            const allowFileTypeMap = platformAllowFileTypeMap[platFormType];
            return Object.keys(allowFileTypeMap);
        } else {
            return ['zip'];
        }

    })();


    onMount(() => {
    });

    function onShow() {

    }

    function save() {
        if (editData.id == null) {
            // 新規登録時
            if (editData.file == null) {
                MessageStore.showConfirmInformation("ファイルの指定が必要です");
                return;
            }

        }

        // editData を formData に変換
        const formData = new FormData();
        for (let key in editData) {
            const value = editData[key];
            formData.set(key, value);
        }


        const url = UrlUtil.createApiUrl("binary");

        isLoading = true;
        HttpRequestUtil.postRequest(url, formData, (response) => {
            isLoading = false;
            console.log(response);
            const body = response['body'];

            close();

            dispatcher('update');

        });
    }

    function close() {
        dispatcher('close');

    }

    function onDelete() {
        const url = UrlUtil.createApiUrl("binary");

        isLoading = true;
        HttpRequestUtil.deleteRequest(url, editData, (response) => {
            isLoading = false;
            console.log(response);
            const body = response['body'];

            close();

            dispatcher('update');
            dispatcher('delete');

        });
    }

    function onAddInputFile(event) {
        const fileArray = event.detail.fileArray;
        if (fileArray.length === 0) {
            editData.file = null;
            return;
        }
        const file = fileArray[0];
        editData.file = file;

        const fileName = file.name;
        if (ValueUtil.isEmpty(editData.name)) {
            editData.name = fileName;
        }

    }

    function onClearInputFile() {
        editData.file = null;
    }

    function resetFile() {
        editData.file = null;
    }

</script>

<PortalView>
    <EditDialogView
            title={title}
            editData={editData}
            on:save={save}
            canSave={canSave}
            canDelete={true}
            on:delete={onDelete}
            on:show={onShow} on:cancel={close}>
        <div class="binary-edit-dialog-content">
            <div>
                <LabelValueView label="スペース名" value={space.name}/>
                <LabelValueView label="アプリ名" value={app.name}/>
            </div>

            <div>
                <div class="row">
                    <InputAreaView label="タイプ">
                        {#if editData.id == null}
                            <select bind:value={editData.type} on:change={resetFile} required>
                                {#each Object.entries(BinaryTable.Type.map) as [id, name]}
                                    <option value={Number(id)}>{name}</option>
                                {/each}

                            </select>
                        {:else}
                            { BinaryTable.PlatformType.map[editData.platform_type]  }
                        {/if}


                    </InputAreaView>
                </div>

                <div class="row">
                    <InputAreaView label="プラットフォーム">
                        {#if editData.id == null}
                            <select bind:value={editData.platform_type} on:change={resetFile} required>
                                <option value={null}></option>
                                {#each Object.entries(BinaryTable.PlatformType.map) as [id, name]}
                                    <option value={Number(id)}>{name}</option>
                                {/each}

                            </select>
                        {:else}
                            { BinaryTable.PlatformType.map[editData.platform_type]  }
                        {/if}


                    </InputAreaView>
                </div>

                <div class="row">
                    <InputAreaView label="バイナリ名">
                        <input type="text" class="name" placeholder="バイナリ名" bind:value={editData.name} required/>

                    </InputAreaView>
                </div>
                <div class="row">
                    <InputAreaView label="CI Job Url">
                        <input type="text" placeholder="CI Job Url(Jenkinsなど)" bind:value={editData.ci_job_url}/>

                    </InputAreaView>
                </div>
                <div class="row">
                    <InputAreaView label="説明"
                                   tipsMessage={"Markdown書式で記載します。普通に書いてもいいし、書式にこだわることもできます。\n行末で半角スペース2つ入れると改行になります。"}>
                        <TextareaView bind:value={editData.description} placeholder="説明" widthEm="32"/>

                    </InputAreaView>


                </div>

                <div class="row file-row">
                    <div class="input-file-area">
                        {#if supportFileExtensionArray != null}
                            <InputFileUploadView
                                    supportFileExtensionArray={supportFileExtensionArray}
                                    isMultiple={false}
                                    on:add={onAddInputFile}
                                    on:clear={onClearInputFile}
                                    isShowActiveFileArray={true}
                            />
                        {/if}

                    </div>
                </div>
            </div>

        </div>

    </EditDialogView>
</PortalView>


<style lang="scss">
    .binary-edit-dialog-content {

        .row {
            .name {
                width: 32em;
            }


            &.file-row {
                margin-top: 12px;
                display: flex;
                align-items: center;
                justify-content: center;

                .input-file-area {
                    width: 600px;
                }
            }
        }
    }
</style>